import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  #observer = null;
  #wasConnected = true;

  connect() {
    this.#observer = new MutationObserver(() => this.#reconcile());
    this.#observer.observe(this.element, { attributeFilter: ['connected'] });
  }

  disconnect() {
    this.#observer.disconnect();
  }

  keepConnected(event) {
    if (event.detail.attributeName === 'connected') event.preventDefault();
  }

  #reconcile() {
    const connected = this.element.hasAttribute('connected');

    if (connected && !this.#wasConnected) Turbo.session.refresh(document.baseURI);

    this.#wasConnected = connected;
  }
}
